import { createContext, useContext } from 'react';

import { DEFAULT_ROOT_NODE_NAME } from '../constants.js';
import type { InternalTreeMapData } from '../types/internal.js';

export const TreeMapInternalDataContext = createContext<InternalTreeMapData>({
  tree: { children: [], name: '', value: 0, id: DEFAULT_ROOT_NODE_NAME },
});

export const useTreeMapInternalData = () =>
  useContext(TreeMapInternalDataContext);

TreeMapInternalDataContext['displayName'] = 'TreeMapRawDataContext';
